import React, { useState } from 'react';
import moment from 'moment/moment';
import { getRuta, simpleMessage } from '../../../../helpers/Helpers';
import {
	BotonGenerar,
	CampoFecha,
	FormularioSelector,
	SelectorGestor
} from '../../../../components/reportes/selector';

const SelectorUsertracking = () => {
	const [selectedGestor, setSelectedGestor] = useState('');
	const [selectedFecha, setSelectedFecha] = useState(new Date());
	const [errorGestor, setErrorGestor] = useState(false);
	let ruta = getRuta();

	const cambiarGestor = (valor) => {
		setSelectedGestor(valor);
		setErrorGestor(false);
	};

	const verReport = () => {
		if (selectedGestor.length === 0) {
			setErrorGestor(true);
			simpleMessage('Seleccione un gestor', 'error');
			return;
		}
		if (!moment(selectedFecha).isValid()) {
			simpleMessage('Seleccione una fecha válida', 'error');
			return;
		}

		// La fecha ya se pedia en pantalla pero no se enviaba, asi que el reporte no tenia
		// como saber que dia mostrar.
		var params = `${selectedGestor}/${moment(selectedFecha).format('YYYY-MM-DD')}`;
		window.open(`${ruta}/r-usertracking/${params}`);
	};
	return (
		<FormularioSelector>
			<SelectorGestor value={selectedGestor} onChange={cambiarGestor} error={errorGestor} />

			<CampoFecha
				label="Seleccione una Fecha"
				value={selectedFecha}
				onChange={setSelectedFecha}
			/>

			<BotonGenerar onClick={verReport} />
		</FormularioSelector>
	);
};
export default SelectorUsertracking;
